export enum GameStateEnum {
  Active = 1,
  Inactive = 2,
  Draft = 3,
  Paused = 4,
  PauseAfterNextDraw = 5,
  PauseAfterNextWinner = 6,
  PauseAfterNextDrawCancelAutoplays = 7,
  PauseAfterNextWinnerCancelAutoplays = 8,
  EndAfterNextDraw = 9,
  EndAfterNextWinner = 10
}
